import { FormsModule } from '@angular/forms';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';

import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { IonicStorageModule } from '@ionic/storage-angular';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { FullscreenImageModalComponent } from './logboek/fullscreen-image-modal/fullscreen-image-modal.component';
import * as Sentry from '@sentry/angular';
import { TraceService } from '@sentry/angular';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';
import { AuthInterceptor } from './auth/auth-interceptor';
import { SharedModule } from '../components/shared.module';
import { API_BASE_URL } from './tokens/api.tokens';
import { environment } from '../environments/environment';
import { FieldTypeRegistryService } from './showreport/dynamic-field/field-type-registry.service';
import { initializeFieldTypes } from './showreport/dynamic-field/field-type-registry.initializer';
import { StorageService } from '../services/storage.service';
import { initializeStorage } from '../services/storage.initializer';

const DEFAULT_LANGUAGE = 'nl';

registerLocaleData(localeNl, DEFAULT_LANGUAGE);

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function initializeTranslations(translateService: TranslateService) {
    return () => translateService.use(DEFAULT_LANGUAGE).toPromise();
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent],
    exports: [FormsModule, FullscreenImageModalComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [AppRoutingModule,
        BrowserModule,
        IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
        IonicStorageModule.forRoot(),
        FormsModule,
        PinchZoomComponent,
        FullscreenImageModalComponent,
        SharedModule,
        TranslateModule.forRoot({
            defaultLanguage: DEFAULT_LANGUAGE,
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        })], providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false
            })
        },
        { provide: TraceService, deps: [Router] },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {
            },
            deps: [TraceService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeTranslations,
            deps: [TranslateService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeFieldTypes,
            deps: [FieldTypeRegistryService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeStorage,
            deps: [StorageService],
            multi: true
        },
        { provide: API_BASE_URL, useValue: environment.apiUrl },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
